module.exports = __webpack_public_path__ + "img/seafile.72797bc8.png";